import { createAction } from 'redux-actions';

export const userAuthenticated = createAction('USER_AUTHENTICATED');
